/* TDP - comportements des sections editables (cf. tdp-sections.css) :
   galerie (grande image + vignettes), cartes projet cliquables, fleche
   animee des liens materiaux. Relance a chaque section rechargee dans
   l'editeur de theme. */
(function () {
  'use strict';
  if (window.tdpSectionsLoaded) return;
  window.tdpSectionsLoaded = true;

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  // Lien "En savoir plus" des materiaux : petite animation de la fleche
  // avant de suivre le lien (comportement natif conserve pour nouvel onglet).
  function initMaterials(root) {
    root.querySelectorAll('.tdp-re-material-caption a').forEach(function (link) {
      if (!once(link, 'tdpArrow')) return;
      link.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        if (link.classList.contains('tdp-arrow-go')) return;
        var href = link.getAttribute('href');
        if (!href) return;
        e.preventDefault();
        link.classList.add('tdp-arrow-go');
        window.setTimeout(function () { window.location.href = href; }, 320);
      });
      link.addEventListener('animationend', function () { link.classList.remove('tdp-arrow-go'); });
    });
  }

  // Toute la carte projet est cliquable vers le lien de son bouton.
  function initCases(root) {
    root.querySelectorAll('.tdp-rl-case').forEach(function (card) {
      if (!once(card, 'tdpCase')) return;
      card.addEventListener('click', function (e) {
        var btn = card.querySelector('.tdp-rl-case-btn');
        var href = btn && btn.getAttribute('href');
        if (!href || e.target.closest('a')) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        window.location.href = href;
      });
    });
  }

  function initGallery(gallery) {
    if (!once(gallery, 'tdpGallery')) return;
    var main = gallery.querySelector('[data-tdp-gallery-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.tdp-rl-gallery-thumb'));
    if (!main || !thumbs.length) return;
    var current = 0;
    var loadedUrls = {};

    function preloadAll() {
      thumbs.forEach(function (t) {
        var url = t.getAttribute('data-full');
        if (loadedUrls[url]) return;
        var img = new Image();
        img.onload = function () { loadedUrls[url] = true; };
        img.src = url;
      });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(preloadAll, { timeout: 3000 });
    else setTimeout(preloadAll, 300);

    function show(i) {
      current = (i + thumbs.length) % thumbs.length;
      var t = thumbs[current];
      var url = t.getAttribute('data-full');
      var position = t.getAttribute('data-position') || 'center';
      thumbs.forEach(function (el, idx) { el.classList.toggle('is-active', idx === current); });
      if (t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      if (loadedUrls[url]) {
        main.style.objectPosition = position;
        main.src = url;
        return;
      }
      main.classList.add('is-loading');
      var loader = new Image();
      loader.onload = function () {
        loadedUrls[url] = true;
        main.style.objectPosition = position;
        main.src = url;
        main.classList.remove('is-loading');
      };
      loader.src = url;
    }
    var prevBtn = gallery.querySelector('.tdp-rl-gallery-arrow--prev');
    var nextBtn = gallery.querySelector('.tdp-rl-gallery-arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { show(idx); }); });
  }

  function init(root) {
    initMaterials(root);
    initCases(root);
    root.querySelectorAll('[data-tdp-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
